let hardResetInProgress = false;

const clearCookies = () => {
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0]?.trim();
    if (!name) return;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  });
};

const clearServiceWorkers = async () => {
  if (!('serviceWorker' in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
};

const clearCacheStorage = async () => {
  if (!('caches' in window)) return;
  const keys = await caches.keys();
  await Promise.all(keys.map((key) => caches.delete(key)));
};

export async function hardResetAndReload() {
  if (hardResetInProgress) {
    console.info('[UPDATE] Hard reset already running');
    return;
  }

  hardResetInProgress = true;

  try {
    console.log('[UPDATE] Hard reset start');

    localStorage.clear();
    sessionStorage.clear();
    clearCookies();
    await clearServiceWorkers();
    await clearCacheStorage();

    console.log('[UPDATE] Hard reset done → reload');
  } catch (error) {
    console.error('[UPDATE] Hard reset failed', error);
  }

  window.location.reload();
}
